import React from "react";
import NavButton from "./NavButton";
import { BsPerson, BsPersonFill } from "react-icons/bs";

interface ProfileButtonProps {
  isActive: boolean;
  onClick: () => void;
}

const ProfileButton: React.FC<ProfileButtonProps> = ({ isActive, onClick }) => {
  return (
    <NavButton
      isActive={isActive}
      onClick={onClick}
      icon={<BsPerson className="h-full w-auto" />}
      fillIcon={<BsPersonFill className="h-full w-auto" />}
      text="Profile"
    />
  );
};

export default ProfileButton;
